import { render, staticRenderFns } from "./saveInfo.vue?vue&type=template&id=394b3339&scoped=true"
import script from "./saveInfo.vue?vue&type=script&lang=js"
export * from "./saveInfo.vue?vue&type=script&lang=js"
import style0 from "./saveInfo.vue?vue&type=style&index=0&id=394b3339&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b3339",
  null
  
)

export default component.exports